<template v-once>
  <img src="@/assets/icons/veeva_icon.svg" alt="veeva icon">
</template>

<script>
export default {
  name: "Veeva",
};
</script>

<style scoped>
</style>